import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Tours from "@/pages/Tours";
import Booking, { BookingLookup } from "@/pages/Booking";
import { AnimalsList, AnimalProfile } from "@/pages/Animals";
import { Visit, Story, Schools, Donate, Contact, FAQ, NotFound, Placeholder } from "@/pages/SimplePages";
import AdminApp from "@/pages/admin/AdminApp";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/viziteaza" element={<Visit />} />
          <Route path="/tururi" element={<Tours />} />
          <Route path="/rezervare" element={<Booking />} />
          <Route path="/rezervare/:code" element={<BookingLookup />} />
          <Route path="/animale" element={<AnimalsList />} />
          <Route path="/animale/:slug" element={<AnimalProfile />} />
          <Route path="/scoli-si-grupuri" element={<Schools />} />
          <Route path="/povestea-noastra" element={<Story />} />
          <Route path="/sustine-ne" element={<Donate />} />
          <Route path="/adopta-simbolic" element={<Donate />} />
          <Route path="/bilete-cadou" element={<Placeholder title="Bilete cadou" />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/intrebari-frecvente" element={<FAQ />} />
          <Route path="/jurnal" element={<Placeholder title="Jurnal" />} />
          <Route path="/politica-confidentialitate" element={<Placeholder title="Politica de confidențialitate" />} />
          <Route path="/politica-cookies" element={<Placeholder title="Politica cookies" />} />
          <Route path="/termeni-si-conditii" element={<Placeholder title="Termeni și condiții" />} />
          <Route path="/politica-anulare-rambursare" element={<Placeholder title="Politica de anulare" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}
